import { api } from '@/helpers/api';

export default {
  async getGrades({ commit }, { studentId, payload }) {
    const response = await api.get(`parent/me/students/${studentId}/grades`, { params: payload });

    const data = response.data.results;
    commit('setGrades', data);
  },

  clearGrades({ commit }) {
    commit('clearGrades');
  },
};
